import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { AuthService } from '../service';

@Component({
  selector: 'security-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
})
export class CallbackComponent implements OnInit {
  #authService = inject(AuthService);

  #router = inject(Router);

  ngOnInit() {
    this.#authService
      .login()
      .pipe(tap(() => this.#router.navigate(['/'])))
      .subscribe();
  }
}
